/* eslint-disable jsdoc/check-indentation */
/**
 * Regex matching game routes: paths starting with a UUID (optionally prefixed with /v2/),
 * with or without a trailing slash or sub-path. Case-insensitive.
 *
 * Matches:
 *   /<UUID>
 *   /<UUID>/
 *   /<UUID>/challenges/...
 *   /v2/<UUID>
 *   /v2/<UUID>/onboarding
 */
const GAME_ROUTE_PATTERN = /^\/(?:v2\/)?[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}(?:\/.*)?$/i;
/* eslint-enable jsdoc/check-indentation */

/**
 * Returns true if the given path is NOT a game route — i.e., the AI assistant should be visible.
 * Game routes are UUID-based paths where participants interact with Jam events.
 *
 * @param currentPath - The current pathname from location
 * @returns true if the path should show the AI assistant
 */
export const isNonGameRoute = (currentPath: string): boolean => {
  return !GAME_ROUTE_PATTERN.test(currentPath);
};
